import { normalizeDomainTarget } from "./ruleDerivation";
import type { TargetDraft } from "./ruleTypes";
import { sanitizeDomainCategories } from "./websiteCategories";

export type SanitizedWebTargetFields = {
  domains: string[];
  domainCategories: string[];
};

export function sanitizeWebTargetFields(
  draft: Pick<TargetDraft, "domains" | "domainCategories">,
): SanitizedWebTargetFields {
  const domains = [...new Set(draft.domains.map(normalizeDomainTarget).filter(Boolean))].sort();
  const domainCategories = [...sanitizeDomainCategories(draft.domainCategories)].sort();
  return { domains, domainCategories };
}

export function draftHasTypedWebContent(draft: Pick<TargetDraft, "domains" | "domainCategories">): boolean {
  const { domains, domainCategories } = sanitizeWebTargetFields(draft);
  return domains.length > 0 || domainCategories.length > 0;
}

/** True when the draft adds typed domains or categories that were not in the baseline. */
export function hasNewTypedWebContent(baseline: TargetDraft, draft: TargetDraft): boolean {
  const base = sanitizeWebTargetFields(baseline);
  const next = sanitizeWebTargetFields(draft);
  const baseDomains = new Set(base.domains);
  const baseCategories = new Set(base.domainCategories);
  if (next.domains.some((domain) => !baseDomains.has(domain))) return true;
  if (next.domainCategories.some((category) => !baseCategories.has(category))) return true;
  return false;
}
